import * as React from 'react'
import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./WebsiteBookingsPage')

export const WebsiteBookingsPage = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => <Module.default {...props} />
})



// WEBPACK FOOTER //
// ./src/routes/WebsiteBookingsPage/index.js